import React, { Component } from 'react';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { compose } from 'redux';
import { connect } from 'react-redux';
import faEye from '@fortawesome/fontawesome-pro-light/faEye';
import noRoomsIcon from "../../images/no-rooms.svg";

import RoomOffer from './RoomOffer';
import RoomOfferLoader from './RoomOfferLoader';
import { setSelectedRoomType } from '../../store/actions';
import T from '../Translate';


class Rooms extends Component {

	handleClickShowAllRooms = (e) => {
		e.preventDefault();

		this.props.dispatch(setSelectedRoomType(null));
	};

	render() {
		const { initiated, isLoading, roomOffers, selectedRoomType, apiRoomsResponse } = this.props;

		const filteredRoomOffers = selectedRoomType !== null ? roomOffers.filter(roomOffer => selectedRoomType.includes(roomOffer.id)) : roomOffers;

		const noRoomReason = !isLoading && !filteredRoomOffers.length
			? (['closed', 'minNights', 'maxNights'].find(field => apiRoomsResponse[field]) || 'empty')
			: undefined;

		return (
			<div className="rooms">
				<div className="room-offers">
					{!initiated &&
					<React.Fragment>
						<RoomOfferLoader />
						<RoomOfferLoader isLast={true} />
					</React.Fragment>
					}

					{initiated && isLoading &&
					<div className="fullscreen-loader">
						<div className="loader loader--large"/>
					</div>
					}

					{initiated &&
					<React.Fragment>
						{filteredRoomOffers.map((roomOffer, index) => {
							return (
								<RoomOffer
									key={index}
									roomOffer={roomOffer}
									isLast={index === filteredRoomOffers.length - 1}
								/>
							);
						})}
						{!isLoading && !filteredRoomOffers.length &&
							<div className="text-center">
								<img src={noRoomsIcon} className="room-offers-empty__icon" alt="" />
								<h2 className="room-offers-empty__title"><T id={`Rooms.index.${noRoomReason}.title`} /></h2>
								<h3 className="room-offers-empty__subtitle"><T id={`Rooms.index.${noRoomReason}.subtitle`} /></h3>
							</div>
						}
					</React.Fragment>
					}
				</div>

				{!!selectedRoomType && filteredRoomOffers.length < roomOffers.length &&
				<div className="rooms-footer">
					<button
						className="rooms-footer__button"
						onClick={this.handleClickShowAllRooms}
					>
						<FontAwesomeIcon icon={faEye} size="lg" className="fa-margin-right" /> <T id="Rooms.index.showAllRooms" />
					</button>
				</div>
				}
			</div>
		);
	}
}

export default compose(
	connect((state) => ({
		initiated: state.app.initiated,
		isLoading: state.app.isLoading,
		roomOffers: state.app.roomOffers,
		selectedRoomType: state.app.selectedRoomType,
		apiRoomsResponse: state.app.apiRoomsResponse,
	}))
)(Rooms);


// WEBPACK FOOTER //
// ./src/components/Rooms/index.jsx